const React = require('react');
const invariant = require('invariant');
const warning = require('warning');
const PropTypes = React.PropTypes;
const RenderingUtils = require('../utils/rendering');
const SpringsMixin = require('../mixins/springs');

const SpringClickGroup = React.createClass({

  propTypes: {
    context: PropTypes.object,
    fullScale: PropTypes.number,
    depressedScale: PropTypes.number,
    defaultSpringTension: PropTypes.number,
    defaultSpringFriction: PropTypes.number,
    defaultSpringInitialValue: PropTypes.number,
    stopPropagation: PropTypes.bool,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
  },


  // TODO(pure-render): should add pure render after function binding
  // issue are fixed
  mixins: [SpringsMixin()],

  getDefaultProps() {
    return {
      depressedScale: 0.8,
      fullScale: 1,
      defaultSpringTension: 200,
      defaultSpringFriction: 15,
      defaultSpringInitialValue: 1,
      style: {},
    };
  },

  componentWillMount() {
    const context = this._getMixinContext();

    React.Children.forEach(this.props.children, (child) => {
      const childProps = child.props || {};
      invariant(child.key, 'Children of SpringClickGroup must define a `key`');

      context.addSpring({
        key: `${ child.key }Child`,
        tension: childProps.springTension || this.props.defaultSpringTension,
        friction: childProps.springFriction || this.props.defaultSpringFriction,
        initialValue: childProps.springInitialValue || this.props.defaultSpringInitialValue,
      });
    });
  },

  componentWillReceiveProps(newProps) {
    const context = this._getMixinContext();

    // check if actions have changed and re-register springs if necessary
    const childrenToRemove = RenderingUtils.diffReactChildren(this.props.children, newProps.children);
    const childrenToAdd = RenderingUtils.diffReactChildren(newProps.children, this.props.children);

    childrenToRemove.forEach((child) => {
      setImmediate(() => {
        context.removeSpring(`${ child.key }Child`);
      });
    });

    childrenToAdd.forEach((child) => {
      const childProps = child.props || {};

      context.addSpring({
        key: `${ child.key }Child`,
        tension: childProps.springTension || this.props.defaultSpringTension,
        friction: childProps.springFriction || this.props.defaultSpringFriction,
        initialValue: childProps.springInitialValue || this.props.defaultSpringInitialValue,
      });
    });
  },

  componentWillUnmount() {
    const context = this._getMixinContext();

    React.Children.forEach(this.props.children, (child) => {
      invariant(child.key, 'Children of SpringClickGroup must define a `key`');

      setImmediate(() => {
        context.removeSpring(`${ child.key }Child`);
      });
    });
  },

  _getMixinContext() {
    // Support sharing a spring context with the owner.
    // If the owner does not specify a context with a Springs Mixin,
    // we can default to one
    return this.props.context || this;
  },

  _onMouseDown(spring, evt) {
    if (evt.nativeEvent._handledBySpringClick) {
      // a SpringClickGroup instance deeper in the DOM has already
      // handled this mouse event, so we should ignore it to prevent
      // this one from springing. This is preferable over stopPropagation
      // as we may still want event propagation to bubble up to other
      // parts of the application.
      return;
    }

    const { depressedScale, stopPropagation } = this.props;
    spring.setEndValue(depressedScale);

    // we write to the nativeEvent on the SyntheticEvent object
    // because React pools (https://facebook.github.io/react/docs/events.html)
    // its synthetic events and custom properties written to it
    // aren't cleared by react and will persist.
    evt.nativeEvent._handledBySpringClick = true;

    if (stopPropagation) {
      evt.stopPropagation();
    }
  },

  _onMouseUp(spring, evt) {
    const { fullScale, stopPropagation } = this.props;
    spring.setEndValue(fullScale);

    if (stopPropagation) {
      evt.stopPropagation();
    }
  },

  _onMouseLeave(spring, evt) {
    const { fullScale, stopPropagation } = this.props;
    spring.setEndValue(fullScale);

    if (stopPropagation) {
      evt.stopPropagation();
    }
  },

  render() {
    const context = this._getMixinContext();

    const children = React.Children.map(this.props.children, child => {
      const childKey = `${ child.key }Child`;
      const springValueKey = `${ childKey }SpringValue`;
      const spring = context.springRefs[childKey];
      const scaleValue = context.state[springValueKey];

      const childStyle = {
        transform: `scale(${ scaleValue })`,
        WebkitTransform: `scale(${ scaleValue })`,
      };

      warning(
        typeof child.type === 'string' ||
        (child.type.propTypes && child.type.propTypes.style),
        `SpringClickGroup child is a composite component that does not specify a \`style\` prop. Check the \`propTypes\` of the child with key: ${ child.key }`
      );

      return React.cloneElement(child, {
        // TODO(fn-bind): should replace with cached function bind
        onMouseDown: this._onMouseDown.bind(this, spring),
        onMouseUp: this._onMouseUp.bind(this, spring),
        onMouseLeave: this._onMouseLeave.bind(this, spring),
        style: childStyle,
      });
    });

    const childCount = React.Children.count(children);
    if (childCount === 0) {
      return null;
    } else if (childCount > 1) {
      return <span style={ this.props.style }>{ children }</span>;
    } else {
      return React.Children.only(children[0]);
    }
  },
});

const SpringClickItem = (props) => {
  invariant(React.Children.count(props.children) <= 1, 'SpringClickItem cannot take multiple children');

  // TODO(react-15): switch to null when we upgrade to react 15
  // see: https://github.com/facebook/react/issues/5355
  return props.children ? (
    <SpringClickGroup { ...props }>
      {React.cloneElement(props.children, { key: 'child' })}
    </SpringClickGroup>
  ) : <noscript />;
};
SpringClickItem.propTypes = {
  children: PropTypes.element.isRequired,
};

module.exports = SpringClickGroup;
module.exports.Item = SpringClickItem;
